meedy.controller('meedy.userCreateController', ['$scope', '$state', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel',
    function ($scope, $state, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel) {

        function setData() {
            $scope.user = new UserMeedyVO();
            $scope.user.partnerType = Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;

            $scope.buttons = [
                {value : Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST, label : 'T.MEEDY.ENUM.USER_PARTNER_TYPE.RECEPTIONIST'},
                {value : Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST, label : 'T.MEEDY.ENUM.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST'}
            ];

            $scope.forms = {
                user : null
            };

            $scope.phoneRegExp = '^\\d+$';
            $scope.hideAddButton();
            $scope.showBackButton();
            $scope.setTitle('T.MEEDY.UI.APPLICATION.NEW_USER');
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
            ||  userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.USER.CREATE.SUCCESS, function(event, user) {
                $state.go(Constant.STATE.APP.MEEDY.SETTINGS.USER.LIST);
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.save = function() {
                $scope.forms.user.$setSubmitted();
                if($scope.forms.user.$valid) {
                    userModel.create($scope.user);
                }
            };

        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.NEW_USER');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
